import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { EditableComponent } from "../EditableComponent/EditableComponent";
import { FieldRenderer } from "../FieldRenderer/FieldRenderer";
import { useFormContext } from "react-hook-form";

import Ic_Order from "../../../../assets/images/mi_reorder-alt.png";
import { useParams } from "react-router-dom";
import { IStepFields } from "../../../../interface/MedicalRecord";
import { getGridColumnClass } from "../../../../utils/fileUtils";
import useAppMediaQuery from "../../../../hooks/window/useAppMediaQuery";
interface SortableFieldProps {
  field: IStepFields;
  isEditable: boolean;
  isCurrentStepVisible: boolean;
  currentStepData: any;
}

const SortableField: React.FC<SortableFieldProps> = ({
  field,
  isEditable,
  isCurrentStepVisible,
  currentStepData,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: `step-field-${field.Id}`,
    disabled: !isEditable,
  });

  const {
    watch,
    formState: { errors },
  } = useFormContext();
  const name = `id_${currentStepData.Id}.StepFields.field_${field.Id}.IsVisible`;
  const isVisible = watch(name);

  const { type } = useParams();
  
  const { isMobileOrTablet } = useAppMediaQuery();

  const isViewTemplate = type === "details";

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isVisible || !isEditable ? "100%" : "30%",
  };

  return field?.IsVisible || isEditable ? (
    <div
      ref={setNodeRef}
      style={style}
      {...(isEditable ? attributes : {})}
      {...(isEditable ? listeners : {})}
      className={`h-fit ${isEditable ? "my-2 cursor-move" : ""} ${isMobileOrTablet? "col-span-12" : getGridColumnClass(field?.ColumnSize || 0)} `}
    >
      {isEditable ? (
        isCurrentStepVisible ? (
          <div className="flex items-center gap-4">
            <img className="h-5 w-5" alt="" src={Ic_Order} />
            <EditableComponent
              name={name}
              component={<FieldRenderer key={field.Id} field={field} />}
              field={field}
            />
          </div>
        ) : (
          <div className="opacity-30">
            <FieldRenderer
              disabled={isViewTemplate}
              key={field.Id}
              field={field}
            />
          </div>
        )
      ) : (
        field?.IsVisible && (
          <FieldRenderer
            disabled={isViewTemplate}
            key={field.Id}
            field={field}
          />
        )
      )}
    </div>
  ) : (
    <></>
  );
};

export default SortableField;
